import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Placeholder for user slice
const initialState = {
  profile: null,
  addresses: [],
  paymentMethods: [],
  wishlist: [],
  orders: [],
  notifications: [],
  energySavings: {
    totalSaved: 0,
    co2Reduced: 0,
    monthlyData: [],
  },
  loading: false,
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { clearError } = userSlice.actions;
export default userSlice.reducer;